/*
  * Something Went Wrong Page * 
  Component : If anything breaks in the app
*/
import { Link } from "react-router-dom";

const SomethingWentWrong = ({ resetState }) => {
  return (
    <div className="something-went-wrong">
      <h1>Oops, something went wrong</h1>
      <p>
        This page is currently not available. We are working on the problem, and
        appreciate your patience.
      </p>
      <Link onClick={resetState} to="/dashboard">
        Back To Dashboard
      </Link>
    </div>
  );
};

export default SomethingWentWrong;
